import { Button, FormItem, Input, Stack, Typography } from '@/components';
import { useAuth } from '@/contexts/AuthContext';
import AppUser from '@/entities/AppUser';
import { updateRemoteUser } from '@/firebase/RemoteUser';
import { useState } from 'react';
import styles from './ProfileView.module.css';

const ProfileView = (): JSX.Element => {
  const { appUser, setAppUser } = useAuth();
  const [firstName, setFirstName] = useState<string>(appUser?.firstName || '');
  const [lastName, setLastName] = useState<string>(appUser?.lastName || '');
  const [googleApiKey, setGoogleApiKey] = useState<string>(
    appUser?.googleApiKey || '',
  );

  const handleModify = async () => {
    if (!appUser) return;

    const appUserUpdated: AppUser = {
      ...appUser,
      firstName: firstName,
      lastName: lastName,
      googleApiKey: googleApiKey,
    };

    try {
      await updateRemoteUser(appUserUpdated, [
        'firstName',
        'lastName',
        'googleApiKey',
      ]);
      setAppUser(appUserUpdated);
    } catch (error) {
      console.error('Failed to update user:', error);
    }
  };

  return (
    <div className={styles.profileView}>
      <Typography variant="titleLarge">My account</Typography>
      <Stack spacing={3}>
        <FormItem>
          <Typography variant="labelMedium">First name</Typography>
          <Input
            placeholder="First name"
            defaultValue={appUser?.firstName}
            onChange={(event) => {
              setFirstName(event.target.value);
            }}
          />
        </FormItem>
        <FormItem>
          <Typography variant="labelMedium">Last name</Typography>
          <Input
            placeholder="Last name"
            defaultValue={appUser?.lastName}
            onChange={(event) => {
              setLastName(event.target.value);
            }}
          />
        </FormItem>
        <FormItem>
          <Typography variant="labelMedium">Google API key</Typography>
          <Input
            placeholder="Google API key"
            defaultValue={appUser?.googleApiKey}
            onChange={(event) => {
              setGoogleApiKey(event.target.value);
            }}
          />
        </FormItem>
      </Stack>
      <Stack>
        <Button label="Modify" onClick={handleModify} />
      </Stack>
    </div>
  );
};

export default ProfileView;
